import { Tooltip } from 'bootstrap'
export const tooltip = {
    mounted: (el) => new Tooltip(el)
}